export default __webpack_public_path__ + "static/p2-8e3fed427a6e4fc6fc4bd88a1494714d.png";